import React from 'react'
import './style.sass'

const ReviewListEmptyState = () => {


  return (
    <div className="pending-review-list-empty-state-container">
      <div className="wrapper">
        <div className="card-container">
          <i className="fa fa-coffee"></i><br />
          <h5>Hurray! No pending reviews :)</h5>
          <p>
            There are no pending reviews for you now. So go an grab yourself a cup of coffee and enjoy life!
          </p>
        </div>
      </div>
    </div>
  )
}

export default ReviewListEmptyState
